export default __webpack_public_path__ + "static/media/sidecar.01bf53ec.png";